import {persistStore, persistReducer} from 'redux-persist';
import AsyncStorage from '@react-native-async-storage/async-storage';
import rootReducer from '../Reducers';
import {configureStore as ReduxStore} from '@reduxjs/toolkit';

/**
 *
 * @returns
 */
const configureStore = () => {
  const persistConfig = {
    key: 'root',
    storage: AsyncStorage,
    whitelist: ['appPreservedConfigSlice', 'deviceConfigSlice', 'hotelLangSlice', 'serverDateTimeSlice', 'guestDetailsSlice', 'hotelSelectorSlice', 'dynamicStyleSlice', 'countryListtSlice', 'documentListSlice', 'notificationSlice', 'translationSlice' ],
  };

  const persistedReducer = persistReducer(persistConfig, rootReducer);

  const store = ReduxStore({
    reducer: persistedReducer,
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware({
        serializableCheck: false,
      }),
  });

  let persistor = persistStore(store);

  return {store, persistor};
};
export default configureStore;
